// @flow
import type { Location } from 'react-router-dom';

const checkoutPath = /.*\/cart\/.*/;
const paymentReturnPath = /.*\/payment-return/;
const awaitingPaymentPath = /.*\/awaiting-payment\/.*/;
const cartOverviewPath = /.*\/cart\/(([0-9a-f]-?)+\/)?overview.*/;

export const selectIsCheckoutPage = (location: Location): boolean =>
  checkoutPath.test(location.pathname) ||
  awaitingPaymentPath.test(location.pathname) ||
  paymentReturnPath.test(location.pathname);

export const selectIsCartOverviewPage = (location: Location): boolean =>
  cartOverviewPath.test(location.pathname) ||
  paymentReturnPath.test(location.pathname);
